import React, { useEffect, useState } from 'react';
import { ShoppingCart, CheckCircle2 } from 'lucide-react';
const NAMES = ['Carlos', 'Martín', 'Juan', 'Pablo', 'Sebastián', 'Nicolás', 'Fernando', 'Andrés', 'Matías', 'Gonzalo', 'Ramiro', 'Tomás', 'Emiliano', 'Santiago', 'Leandro'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Paraná'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    };
    const initialTimeout = setTimeout(showPopup, 4000);
    const interval = setInterval(() => {
      const randomDelay = Math.floor(Math.random() * 4000) + 8000;
      setTimeout(showPopup, randomDelay);
    }, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div aria-live="polite" aria-atomic="true" className="fixed bottom-4 left-4 z-50" data-id="element-205">
      {isVisible && <div role="status" className="bg-[#1a1a1a] rounded-lg shadow-xl border border-amber-800/40 p-4 flex items-center gap-4 max-w-sm animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-206">
          <div className="bg-amber-900/30 p-2 rounded-full flex-shrink-0" aria-hidden="true" data-id="element-207">
            <ShoppingCart className="w-6 h-6 text-amber-500" data-id="element-208" />
          </div>
          <div data-id="element-209">
            <p className="text-sm font-medium text-white" data-id="element-210">
              <span className="font-bold" data-id="element-211">{data.name}</span> de{' '}
              <span className="font-bold" data-id="element-212">{data.city}</span>
            </p>
            <p className="text-xs text-gray-400 flex items-center mt-1" data-id="element-213">
              <CheckCircle2 className="w-3 h-3 mr-1 text-green-500" aria-hidden="true" data-id="element-214" />
              Acaba de comprar el Mega Pack
            </p>
          </div>
        </div>}
    </div>;
}